<template>
    <div>
        <b-input-group size="sm" :prepend="title">
            <b-link v-if="!isEditing" style="text-overflow: ellipsis; overflow: hidden;" :href="buildHref" class="form-control text-primary">{{ inputValue }}</b-link>
            <b-input ref="input" v-else v-model="inputValue" v-on:keyup.enter="save"></b-input>

            <b-input-group-append>
                <b-button-group v-if="isEditing">
                    <b-button size="sm" text="Button" variant="outline-success" @click="save">
                        <b-icon-check></b-icon-check>
                    </b-button>

                    <b-button size="sm" text="Button" variant="outline-danger" @click="cancelSave">
                        <b-icon-x></b-icon-x>
                    </b-button>
                </b-button-group>

                <b-button v-else size="sm" text="Button" variant="outline-secondary" @click="toggleEditing">
                    <b-icon-pencil-square></b-icon-pencil-square>
                </b-button>
            </b-input-group-append>
        </b-input-group>

    </div>
</template>

<script>
    export default {
        name: "editableInput",
        props: [ 'name', 'value', 'href', 'title' ],
        data() {
            return {
                isEditing: false,
                originalValue: null,
                inputValue: null,
            }
        },
        created() {
            this.inputValue = this.value;
        },
        methods: {
            save() {
                this.$emit('updateInput', this.inputValue);

                this.toggleEditing();
            },
            cancelSave() {
                this.inputValue = this.value;
                this.toggleEditing();
            },
            toggleEditing() {
                this.isEditing = !this.isEditing;

                if (this.isEditing) {
                    this.originalValue = this.value;
                }

                this.$nextTick(() => {
                    if (this.isEditing) {
                        this.$refs.input.$el.focus();
                    }
                });
            }
        },
        computed: {
            buildHref() {
                return this.href + this.inputValue;
            },
        }
    }
</script>

<style scoped>
    .input-group-text {
        width: 8rem;
    }
</style>